import React from 'react';
import { Link } from 'react-router-dom';
import '../../../styles/base_template.scss';

import { clearCampaignAggCache } from '../../../store/actions';
import { withRouter } from '../../../utils/withRouter';
import { connect } from 'react-redux';
import allowUber from "../../uber/allowUber";

class sideNav extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      allow_uber: false
    };
  }

  async componentDidMount() {
    const allow_uber = await allowUber({campaign_id: this.props.campaign_id});
    this.setState({ allow_uber });
  }

  render() {
    const { allow_uber } = this.state;
    return (
      <aside className="flx__nav">
        <div className="nav-title-navbar">
          <div className="nav-title-logo-bak-navbar"></div>
          <div className="nav-title-logo-navbar no-select">
            <img src={'/logo-full192.png'} alt={'ElecTrek'} className={'shadow-sharp'} />
          </div>
        </div>
        <div className="nav-body-navbar">
          <div className="media-lg">
            <Link to="/dash">
              <div
                className={`nav-item main-nav-item noselect ${
                  this.props.location.pathname.includes('/dash') ? 'focused' : ''
                }`}
              >
                <div className={`nav-item-label`}>DASHBOARD</div>
                <div className="nav-item-icon">
                  <i className="fas fa-home"></i>
                </div>
              </div>
            </Link>

            <Link to="/site">
              <div
                className={`nav-item main-nav-item noselect ${
                  this.props.location.pathname === '/site' ? 'focused' : ''
                }`}
              >
                <div className={`nav-item-label`}>SITES</div>
                <div className="nav-item-icon">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
              </div>
            </Link>
            <Link to="/script">
              <div
                className={`nav-item main-nav-item noselect ${
                  this.props.location.pathname === '/script' ? 'focused' : ''
                }`}
              >
                <div className={`nav-item-label `}>SCRIPTS</div>
                <div className="nav-item-icon">
                  <i className="fas fa-sitemap"></i>
                </div>
              </div>
            </Link>
            <Link to="/canvasser">
              <div
                className={`nav-item main-nav-item noselect ${
                  this.props.location.pathname === '/canvasser' ? 'focused' : ''
                }`}
              >
                <div className={`nav-item-label`}>CANVASSERS</div>
                <div className="nav-item-icon">
                  <i className="fas fa-users ''"></i>
                </div>
              </div>
            </Link>
            <Link to="/sitecanvass">
              <div
                className={`nav-item main-nav-item noselect ${
                  this.props.location.pathname.includes('/sitecanvass') ? 'focused' : ''
                }`}
              >
                <div className={`nav-item-label`}>SITE CANVASSES</div>
                <div className="nav-item-icon">
                  <i className="fas fa-walking ''"></i>
                </div>
              </div>
            </Link>
            <Link to="/doorcanvass">
              <div
                className={`nav-item main-nav-item noselect ${
                  this.props.location.pathname.includes('/doorcanvass') ? 'focused' : ''
                }`}
              >
                <div className={`nav-item-label`}>DOOR CANVASSES</div>
                <div className="nav-item-icon">
                  <i className="fas fa-door-open ''"></i>
                </div>
              </div>
            </Link>
            <Link to="/survey">
              <div
                className={`nav-item main-nav-item noselect ${
                  this.props.location.pathname.includes('/survey') ? 'focused' : ''
                }`}
              >
                <div className={`nav-item-label`}>SURVEYS</div>
                <div className="nav-item-icon">
                  <i className="fas fa-clipboard-list"></i>
                </div>
              </div>
            </Link>            
            <Link to="/map" onClick={clearCampaignAggCache}>
              <div
                className={`nav-item main-nav-item noselect ${
                  this.props.location.pathname === '/map' ? 'focused' : ''
                }`}
              >
                <div className={`nav-item-label`}>TRACKING</div>
                <div className="nav-item-icon">
                  <i className="fas fa-flag-checkered ''"></i>
                </div>
              </div>
            </Link>
            <Link to="/map-report">
              <div
                className={`nav-item main-nav-item noselect ${
                  this.props.location.pathname === '/map-report' ? 'focused' : ''
                }`}
              >
                <div className={`nav-item-label`}>MAP REPORTS</div>
                <div className="nav-item-icon">
                  <i className="fas fa-map-marked"></i>
                </div>
              </div>
            </Link>
            {allow_uber && (
                <Link to="/uber-rides">
                  <div
                      className={`nav-item main-nav-item noselect ${
                          this.props.location.pathname === '/uber-rides' ? 'focused' : ''
                      }`}
                  >
                    <div className={`nav-item-label`}>UBER RIDES</div>
                    <div className="nav-item-icon">
                      <i className="fas fa-car"></i>
                    </div>
                  </div>
                </Link>
            )}
            {this.props.is_admin === true && (
              <Link to="/admin/users">
                <div
                  className={`nav-item main-nav-item noselect ${
                    this.props.location.pathname.startsWith('/admin') ? 'focused' : ''
                  }`}
                >
                  <div className={`nav-item-label`}>ADMIN</div>
                  <div className="nav-item-icon">
                    <i className="fas fa-cog ''"></i>
                  </div>
                </div>
              </Link>
            )}
            <Link to="/account/logout">
              <div className={`nav-item main-nav-item noselect`}>
                <div className={`nav-item-label`}>LOGOUT</div>
                <div className="nav-item-icon">
                  <i className="fas fa-sign-out-alt"></i>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </aside>
    );
  }
}

const mapStateToProps = (state) => ({
  is_admin: state.permissions.is_admin,
  campaign_id: state.session.focusedCampaign?.id,
});

export default connect(mapStateToProps, null)(withRouter(sideNav));
